/*** IMPORTS FROM imports-loader ***/
(function() {

(() => {
  class VersionCheckImage {
    static bindErrorEvent(imageElement) {
      imageElement.off('error').on('error', () => imageElement.hide());
    }
  }

  window.gl = window.gl || {};
  gl.VersionCheckImage = VersionCheckImage;
})();

}.call(window));


// WEBPACK FOOTER //
// ./version_check_image.js.es6